/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import userServices from '../../../../commonServices/UserServices';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

export default function UserListing(props) {
    const screenCode = 'USERROLE';
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        roleLevelID: "0",
        groupID: "0",
        operationEntityID: "0",
    });
    const [roleLevels, setRoleLevels] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const UserRoleSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        operationEntityID: Yup.number().min(1, 'Please select a Operation Entity').required('Operation Entity Required'),
        roleLevelID: Yup.number().min(1, 'Please select a role').required('Role Required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            roleLevelID: formData.roleLevelID
        },
        validationSchema: UserRoleSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetUserRoles(values.groupID, values.operationEntityID, values.roleLevelID));
        },
    });

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        const storedUserRolesFormData = JSON.parse(sessionStorage.getItem('userRolesFormData'));
        getPermissions(storedUserRolesFormData);
        sessionStorage.removeItem('userRolesFormData');
    }, []);

    useEffect(() => {
        GetOperationEntityByGroupID();
        setTableData([]);
        formik.setValues({
            ...values,
            operationEntityID: "0",
            roleLevelID: "0"
        });
    }, [formik.values.groupID]);

    useEffect(() => {
        setTableData([]);
        formik.setValues({
            ...values,
            roleLevelID: "0"
        });
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setTableData([]);
    }, [formik.values.roleLevelID]);

    async function getPermissions(storedUserRolesFormData) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWUSERROLE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });
        const isInitialLoading = storedUserRolesFormData === null
        if (isInitialLoading) {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
            })
        }
        else {
            setValues({
                ...values,
                groupID: parseInt(storedUserRolesFormData.groupID),
                operationEntityID: parseInt(storedUserRolesFormData.operationEntityID),
                roleLevelID: parseInt(storedUserRolesFormData.roleLevelID)
            });
            if (storedUserRolesFormData.roleLevelID !== 0) {
                trackPromise(GetUserRoles(storedUserRolesFormData.groupID, storedUserRolesFormData.operationEntityID, storedUserRolesFormData.roleLevelID));
            }
        }
        GetAllGroups();
        GetRoleLevles();
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await services.GetFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    async function GetUserRoles(groupID, operationEntityID, levelID) {
        var res = await services.getUserRole(groupID, operationEntityID, levelID);
        if (res != null) {
            setTableData(res)
        }
    }

    async function GetRoleLevles() {
        var res = await userServices.getRoleLevels()
        if (res != null) {
            setRoleLevels(res);
        }
    }

    async function clearAll() {
        formik.setValues({
            ...values,
            operationEntityID: "0",
            roleLevelID: "0"
        });
        setTableData([]);
    }

    let encrypted = "";
    function handleClick(datas) {
        sessionStorage.setItem('userRolesFormData', JSON.stringify(values));
        encrypted = AESEncryptionParam(datas.roleID.toString());
        navigate('/dashboard/userRole/AddEdit/' + encrypted)
    }

    function handlePermissionClick(datas) {
        sessionStorage.setItem('userRolesFormData', JSON.stringify(values));
        encrypted = AESEncryptionParam(datas.roleID.toString());
        let encrypted1 = AESEncryptionParam(datas.roleLevelID.toString());
        let encrypted2 = AESEncryptionParam(datas.roleName);
        navigate('/dashboard/rolePermission/listing/' + encrypted + "/" + encrypted1 + "/" + encrypted2)
    }

    return (
        <>
            <LoadingComponent />
            <Page title="User Role |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/userRole/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add Role"
                        pageName="User Roles"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Operation Entity</MenuItem>
                                        {operationEntityList.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Role Level *"
                                        value={formik.values.roleLevelID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('roleLevelID')}
                                        error={Boolean(touched.roleLevelID && errors.roleLevelID)}
                                        helperText={touched.roleLevelID && errors.roleLevelID}
                                    >
                                        <MenuItem key={0} value={0}> Select Role</MenuItem>
                                        {roleLevels.map((option) => (
                                            <MenuItem key={option.roleLevelID} value={option.roleLevelID}>
                                                {option.roleLevelName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <Stack
                                        direction={{ xs: 'column', sm: 'row' }}
                                        justifyContent="right"
                                        spacing={2}
                                    >
                                        <Button
                                            type="button"
                                            color="error"
                                            size="small"
                                            variant="outlined"
                                            onClick={() => clearAll()}
                                            style={{ width: '70px', height: '40px' }}
                                        >
                                            Clear
                                        </Button>
                                        <Button
                                            type="submit"
                                            size="small"
                                            color="secondary"
                                            variant="outlined"
                                            style={{ width: '70px', height: '40px' }}
                                        >
                                            Search
                                        </Button>
                                    </Stack>

                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Roles" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Role Level</TableCell>
                                                <TableCell align="center">Role Name</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {tableData.map((row) => (
                                                <TableRow key={row.roleID}>
                                                    <TableCell component="th" scope="row">
                                                        {row.roleLevelName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.roleName}
                                                    </TableCell>
                                                    <TableCell align="center">{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="center">{
                                                        <div>
                                                            <IconButton aria-label="delete" onClick={() => handleClick(row)} >
                                                                <EditIcon />
                                                            </IconButton>
                                                            <IconButton aria-label="delete" onClick={() => handlePermissionClick(row)} >
                                                                <FormatListBulletedIcon />
                                                            </IconButton>
                                                        </div>
                                                    }</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}